var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "eatself-carte" }, [
    _c(
      "div",
      { attrs: { id: "cat-navbar" } },
      [
        _vm.item.product.ty != _vm.PRODUCT_TYPES.Menu
          ? _c("breadcrumbs", {
              attrs: { list: _vm.bcList, current: _vm.activeItem },
              scopedSlots: _vm._u(
                [
                  {
                    key: "default",
                    fn: function (props) {
                      return [
                        _c(
                          "a",
                          {
                            staticStyle: { "text-transform": "none" },
                            attrs: {
                              href: _vm.UrlService.itemHref(props.item),
                            },
                          },
                          [_vm._v(_vm._s(props.item.product.dn))]
                        ),
                      ]
                    },
                  },
                ],
                null,
                false,
                4192436701
              ),
            })
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.shop.info.display.itemChildList
      ? _c(
          "div",
          _vm._l(_vm.treeItems, function (item, i) {
            return _c("list-item", {
              key: i,
              staticClass: "tree-item",
              attrs: {
                id: _vm.UrlService.dashifyItem(item),
                item: item,
                shop: _vm.shop,
              },
            })
          }),
          1
        )
      : _c(
          "div",
          _vm._l(_vm.treeItems, function (item2, i) {
            return _c("grid-item", {
              key: i,
              staticClass: "tree-item",
              attrs: {
                id: _vm.UrlService.dashifyItem(item2),
                item: item2,
                shop: _vm.shop,
              },
            })
          }),
          1
        ),
    _vm._v(" "),
    _c("div", {
      staticClass: "mobile-footer bg-grey3",
      staticStyle: { "padding-top": "100px" },
    }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }